// extracted by mini-css-extract-plugin
export default {"cell":"CustomCell_cell__iF1iB"};